import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const api = process.env.REACT_APP_API_ADDRESS;

export const coursesApi = createApi({
    reducerPath: 'coursesApi',
    tagTypes: ['Courses', 'Tags'],
    baseQuery: fetchBaseQuery({
        baseUrl: api,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if(token) headers.set("token", token);
            return headers;
        }
    }),

    endpoints: (builder) => ({

        GetCourses: builder.query({
            query: (params) => ({
                url: `/api/courses/get`,
                method: "GET",
                params
            }),
            providesTags: ["Courses"]
        }),

        GetCourse: builder.mutation({
            query: (params) => ({
                url: `/api/courses/get`,
                method: "GET",
                params
            }),
            invalidatesTags: ["Courses"]
        }),

        UpdateCourse: builder.mutation({
            query: (body) => ({
                url: `/api/courses/update`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Courses"]
        }),

        createCourse: builder.mutation({
            query: (body) => ({
                url: `/api/courses/create`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Courses"]
        }),

        DeleteCourse: builder.mutation({
            query: (body) => ({
                url: `/api/courses/delete`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Courses"]
        }),

        DeleteModules: builder.mutation({
            query: (body) => ({
                url: `/api/courses/modules/delete`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Courses"]
        }),

        DeleteLessons: builder.mutation({
            query: (body) => ({
                url: `/api/courses/lessons/delete`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Courses"]
        })

    }),
  })

export const {
    useCreateCourseMutation,
    useGetCourseMutation,
    useGetCoursesQuery,
    useUpdateCourseMutation,
    useDeleteLessonsMutation,
    useDeleteModulesMutation,
    useDeleteCourseMutation,
} = coursesApi;